export default __webpack_public_path__ + "static/media/pdf.f7f4aa8b.png";